import { definePageMetaTags, type MetaTagsProps } from 'svelte-meta-tags'

const align = (colWidths: number[], text: string, col: number) => text.padEnd(colWidths[col])

const separator = (colWidths: number[], col: number) => '-'.repeat(colWidths[col])

export const createMdTable = (headers: string[], rows: (string | number)[][]) => {
	const colWidths = headers.map((h, i) =>
		Math.max(h.length, ...rows.map(r => String(r[i] ?? '').length))
	)

	return [
		`| ${headers.map((h, i) => align(colWidths, h, i)).join(' | ')} |`,
		`| ${headers.map((_, i) => separator(colWidths, i)).join(' | ')} |`,
		...rows.map(r => `| ${r.map((c, i) => align(colWidths, String(c ?? ''), i)).join(' | ')} |`),
	].join('\n')
}

export const getPageMetaTags = ({
	title,
	description,
	canonical,
	image,
	robots,
}: {
	title?: MetaTagsProps['title']
	description?: MetaTagsProps['description']
	canonical?: MetaTagsProps['canonical']
	image: string
	robots?: MetaTagsProps['robots']
}) =>
	definePageMetaTags({
		title,
		description,
		canonical,
		robots,
		openGraph: {
			url: canonical,
			title,
			description,
			image: { url: image },
		},
		twitter: {
			title,
			description,
			image,
		},
	})
